import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-frontend-text-area',
  standalone: false,
  templateUrl: './frontend-text-area.component.html',
  styleUrls: ['./frontend-text-area.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrontendTextAreaComponent implements OnInit {
  @Input()
  value?: any;
  @Input()
  title?: string;
  @Input()
  placeHolder?: string;
  @Input()
  required: boolean = false;
  @Input()
  disabled: boolean = false;
  @Input()
  type?: string;
  @Output()
  valueChange: EventEmitter<any> = new EventEmitter();
  @Input()
  lookup?: string;
  @Output()
  lookupSelected: EventEmitter<any> = new EventEmitter();
  originalType?: string;

  constructor(private matDialog: MatDialog) {
  }

  ngOnInit() {
    this.originalType = this.type;
  }

  onChange() {
    this.valueChange.emit(this.value);
  }

  onMouseEnter() {
  }

  onMouseLeave() {
  }
}
